<template>
  <CartInfoCard
    :infoValue="value"
    :text="text"
    :subtitle="subtitle"
    :imgSrc="serviceImg"
    :editable="editable"
    @edit="edit"
  />
</template>
<script>
import CartInfoCard from "./CartInfoCard.vue";
export default {
  name: "CartInfoServiceCard",
  props: {
    shippingAddress: { type: Object, required: true },
    editable: { type: Boolean, default: false }
  },
  components: { CartInfoCard },
  computed: {
    value() {
      return this.$t(
        "navbar.service." + this.shippingAddress.deliveryServiceId + ".name",
        this.shippingAddress
      );
    },
    subtitle() {
      return this.$t("navbar.serviceCardSubtitle");
    },
    text() {
      return this.$t("navbar.serviceSelected");
    },
    serviceIcon() {
      return (
        "$" +
        this.$t(
          "navbar.service." +
            this.shippingAddress.deliveryServiceId +
            ".fontIcon"
        )
      );
    },
    serviceImg() {
      return this.$t(
        "navbar.service." + this.shippingAddress.deliveryServiceId + ".icon"
      );
    }
  },
  methods: {
    edit() {
      if (this.editable) {
        this.$emit("edit");
      }
    }
  }
};
</script>
